import React, { ReactNode } from 'react';

import { getLayout as getSiteLayout } from 'components/Layouts/SiteLayout';
import Layout from 'components/new/layout';

export const getLayout = (page: ReactNode): ReactNode =>
  getSiteLayout(<Layout.CommunityApp>{page}</Layout.CommunityApp>);

export default getLayout;
